<button id="btnMenuUsers" [matMenuTriggerFor]="editar" class="button context button-focusable" tabindex="1">
  <img src="./assets/img/icon_context.svg" title="{{ 'contextChange.TITLE' | translate }}" alt="{{ 'contextChange.TITLE' | translate }}"/>
</button>
<mat-menu #editar="matMenu" class="header-menu-context"> 
  <app-context></app-context>
</mat-menu>